// @flow
import {
  connectWebActions,
  connectWebComponents,
  autoTitleLinksWithBlankTarget,
} from 'fg-frontend';
import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy({ enableImg: false });
phoneLink();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js